import request from '@/utils/request'
const BASE_URL = '/RpBankCheckIn'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  list2(data) {
    return request({
      url: BASE_URL + '/List2',
      method: 'post',
      data
    })
  },
  getAmount(data) {
    return request({
      url: BASE_URL + '/GetCurrentAmount',
      method: 'post',
      data
    })
  },
  dayList(data) {
    return request({
      url: BASE_URL + '/DayList',
      method: 'post',
      data
    })
  },
  bankCheckInSum(data) {
    return request({
      url: BASE_URL + '/GetBankCheckInSum',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  saveList(data) {
    return request({
      url: BASE_URL + '/SaveList',
      method: 'post',
      data
    })
  },
}